import React, {useEffect, useState} from 'react'

import BasePage from "../../Components/BasePage/BasePage";

import './ChoixPortePage.scss'
import BaseButton from "../../Components/BaseButton/BaseButton";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {StateModel} from "../../Models/StateModel";
import {DoorModel} from "../../Models/DoorModel";
import {setDoor} from "../../store/actions";
import {useError} from "../../hooks/useError";
import {useGetEvent} from "../../hooks/useGetEvent";
import Error from "../../Components/Error/Error";

const ChoixPortePage: React.FC = ({}) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const doors = useSelector<StateModel, DoorModel[]>(state => state.stadium?.doors || [])
    const eventError = useError()
    const apiError = useError()
    const getEvent = useGetEvent(() => eventError.open(""), () => apiError.open(""))

    const [searchParams,] = useSearchParams();
    const stadium = searchParams.get("stadium") ?? undefined;

    const [choice, setChoice] = useState<string | null>(null)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        getEvent(stadium)
    }, [stadium])

    const submit = () => {
        const door = doors.find(d => d.name.toLowerCase() === choice?.toLowerCase())
        if(!door) {
            setError(`${stadium === "BMA" ? "Le bloc " : "La porte"} ${choice} n'existe pas`)
        } else {
            setError(null)
            dispatch(setDoor(door))
            navigate(`/stands?stadium=${searchParams.get("stadium")}&doorId=${door.id}`)
        }
    }

    return (
        <BasePage showLogo showHistorique showPanier>
            <p className="choixPortePageText">Saisissez {stadium === "BMA" ? "le bloc auquel " : "la porte à laquelle"} vous vous trouvez</p>
            <p className="choixPortePageSubText">Votre numéro de {stadium === "BMA" ? "bloc " : "porte"} figure sur votre billet.</p>
            <div className="choixPortePageTextInputContainer">
                <input className="choixPortePageInput" placeholder="Ex: 102" onKeyUp={(e: any) => setChoice(e.target.value)}/>
                <small className="choixPortePageError">{error}</small>
            </div>
            <BaseButton onClick={submit} text="Valider" className="choixPortePageBtn" disabled={!choice}/>
            <Error show={eventError.visible} title={"Aucun événement en cours, revenez bientôt!"} subTitle={"Pas d'événement, pas de commande ! Mais nous serons bientôt de retour."} />
            <Error show={apiError.visible} title={"Le service n’est pas disponible actuellement"} subTitle={"Veuillez vous rendre à un stand pour plus d’informations."} />
        </BasePage>
    )
}

export default ChoixPortePage;
